"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ellipsis = void 0;
var ellipsis_1 = require("./ellipsis");
Object.defineProperty(exports, "Ellipsis", { enumerable: true, get: function () { return ellipsis_1.Ellipsis; } });
//# sourceMappingURL=index.js.map